import consts, {API_VERSION, BASE_URL} from "../consts";
import React from "react";
import utils from "../common/utils";
import {CLEAR_USER_DATA} from "../redux/actions/user/action_types";
import {LOGOUT} from "../redux/actions/login/action_types";
import _ from 'lodash'

const str = {
  "Blockchain address invalid": "BLOCK_CHAIN_ADDRESS_NOT_EXIST_ERROR",
  "Blockchain address not exist": "BLOCK_CHAIN_ADDRESS_NOT_EXIST_ERROR",
}

export default class BaseRequest {
  version = "v1/cryptotrading";

  prefix () {
    return '';
  }

  async get(url, params = {}, showNoti = true) {
    try {
      const response = await window.axios.get(`${this.version}/${url}`, { params });
      return this._responseHandler(response, showNoti);
    } catch (error) {
      this._errorHandler(error);
    }
  }

  async getWithTimeout(url, params = {}, timeout, showNoti = true) {
    try {
      const response = await window.axios.get(`${this.version}/${url}`, { params, timeout });
      return this._responseHandler(response, showNoti);
    } catch (error) {
      this._errorHandler(error);
    }
  }

  async put (url, data = {}, showNoti = true) {
    try {
      const response = await window.axios.put(`${this.version}/${url}`, data);
      return this._responseHandler(response, showNoti);
    } catch (error) {
      this._errorHandler(error);
    }
  }

  async post(url, data = {}, showNoti = true) {
    try {
      const response = await window.axios.post(`${this.version}/${url}`, data);
      return this._responseHandler(response, showNoti);
    } catch (error) {
      this._errorHandler(error);
    }
  }

  async del(url, params = {}, showNoti = true) {
    try {
      const response = await window.axios.delete(`${this.version}/${url}`, params);
      return this._responseHandler(response, showNoti);
    } catch (error) {
      this._errorHandler(error);
    }
  }

  async _responseHandler (response, showNoti) {
    const {data} = response;
    let errorCode = window._.get(data, 'error.code', 200);

    if (errorCode >= 400) {
      if (!showNoti) {
        throw 'Request failed';
      }


      let message = window.$t(data.error.message);
      let errorsNode = undefined;

      if (typeof(data.error.message) === 'string') {
        errorsNode = <div style={{ fontWeight: 'bold', color: 'red' }}>
          {utils.upperCaseFirst(window.$t(_.get(str, message) || message))}
        </div>
      } else {
        errorsNode = window._.map(data.error.message, (message, field) => <div style={{ fontWeight: 'bold', color: 'red' }} id={field}>
          {utils.upperCaseFirst(window.$t(message, { field: window.$t(field) }))}
        </div>)
      }
  
      console.log(data.error.message, ': data.error.message src/requests/BaseRequest.js:82');
      
      utils.showNotification(<span style={{ color: 'red', fontWeight: 'bold' }}>{window.$t('Error')}</span>, errorsNode, consts.TYPE_ERROR);
  
      if (errorCode === 405) {
        window.h.push("/login");
        window.dispatch({
          type: LOGOUT
        });
        localStorage.clear();
      }

      throw 'Request failed';
    }

    return data;
  }

  _errorHandler(err) {
    if (err.response && err.response.status === 401) { // Unauthorized (session timeout)
      window.location.href = '/';
    }
    throw err;
  }

  getFile(url) {
    window.location.href = `${BASE_URL}/${API_VERSION}/${url}`;
  }
}
